<template>

    <div class="container card p-5 shadow w-100">
        
        <h1>Reorder Test Type </h1>
        <hr>
        <div v-if="response.success != null" v-bind:class="{ 'alert-success': response.success, 'alert-danger': !response.success }" class="alert" role="alert">
            {{response.message}}
        </div>

        <ul>
            <li>Move the pointer to the desired Test Type in the list</li>
            <li>Press, and hold down, the button on the mouse to "grab" the desired Test Type</li>
            <li>"Drag" the Test Type to the desired location by moving the pointer to this one</li>
            <li>"Drop" the Test Type by releasing the button</li>
        </ul>
        

        
        <draggable 
            :list="testTypes" 
            v-bind="dragOptions"
            class="list-group mb-3"
            ghost-class="ghost"
            tag="ul"
            >
            <transition-group type="transition" name="flip-list">
                <li class="list-group-item" v-for="element in testTypes" :key="element.id">
                    <i
                        :class=" element.fixed ? 'fa fa-anchor' : 'glyphicon glyphicon-pushpin'"
                        @click="element.fixed = !element.fixed"
                        aria-hidden="true"
                    ></i>
                    {{element.title}} 
                    <icon style="float: right;" icon="arrows-alt" />
                </li>
        
            </transition-group>
        </draggable>

        
        <button @click="reorderTestTypes()" type="button" class="btn btn-primary mb-3">Reorder TestTypes</button>
        
    </div>

</template>

<script>
import draggable from 'vuedraggable';
export default {
    data() {
        return {
            testTypes: [],
            response: {}
        }
    },
    methods: {
        loadTestTypes: function() {
            let self = this;
            this.$http.get('/api/test-types/get-all')
            .then(response => {
                self.testTypes = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
        reorderTestTypes: function() {
            let self = this;
            this.$http.put('/api/test-types/reorder', this.testTypes)
            .then(response => {
                
                self.response = response.data;
            })
            .catch(error => {
                console.log(error);
            })
        },
    },
    mounted: function() {
        this.loadTestTypes();
    },
    watch: {
        response: function(val){
            if(val.success === true)
            {
                setTimeout(() => {this.$router.push("/admin/test-types/");}, 1000)
            }
            setTimeout(() => {this.response.success = null}, 3000)
        }
    },
    components: {
            draggable,
    },
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    }
}
</script>

<style lang="scss" scoped>
.flip-list-move {
  transition: transform 0.5s;
}
.no-move {
  transition: transform 0s;
}
.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
.list-group {
  min-height: 20px;
}
.list-group-item {
  cursor: move;
}
.list-group-item i {
  cursor: pointer;
}
</style>